import React from 'react';
import { Activity } from './types';

interface ActivityToolbarProps {
  activity: Activity;
  onSave: () => void;
  onPreview: () => void;
  onDelete: () => void;
  onAiAssist?: () => void;
  isSaving: boolean;
}

const ActivityToolbar: React.FC<ActivityToolbarProps> = ({
  activity,
  onSave,
  onPreview,
  onDelete,
  onAiAssist,
  isSaving
}) => {
  return (
    <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border-b border-gray-200">
      <div className="flex items-center">
        <span className="text-sm font-semibold text-gray-800 mr-2">
          {activity.title}
        </span>
        <span className="px-2 py-0.5 bg-blue-100 text-blue-800 text-xs font-medium rounded-full">
          {activity.type}
        </span>
      </div>
      
      <div className="flex items-center space-x-2">
        {onAiAssist && (
          <button
            onClick={onAiAssist}
            className="flex items-center px-3 py-1.5 bg-purple-600 text-white rounded-md text-sm hover:bg-purple-700 transition-colors"
            title="AI Assistant"
          >
            <svg className="w-4 h-4 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 16V16.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 13C11.9816 12.6037 12.1048 12.2159 12.3533 11.9158C12.6017 11.6158 12.9561 11.4249 13.35 11.385C13.5731 11.3607 13.7962 11.3607 14.0193 11.385C14.2424 11.4093 14.4593 11.4578 14.6641 11.5289C14.8689 11.6 15.0592 11.6931 15.2294 11.8054C15.3996 11.9177 15.5475 12.0479 15.6682 12.1923C15.7889 12.3367 15.8809 12.4936 15.9407 12.6573C16.0005 12.821 16.0275 12.9897 16.0207 13.1586C16.0139 13.3275 15.9734 13.4936 15.9009 13.6516C15.8283 13.8095 15.7247 13.9571 15.5941 14.0894C15.4636 14.2216 15.3079 14.3367 15.1329 14.4301C14.9579 14.5235 14.7662 14.5941 14.5654 14.6387C14.3646 14.6833 14.1574 14.7013 13.95 14.692C13.6561 14.6921 13.3656 14.6271 13.1 14.502" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M9 10C9 9.20435 9.31607 8.44129 9.87868 7.87868C10.4413 7.31607 11.2044 7 12 7C12.7956 7 13.5587 7.31607 14.1213 7.87868C14.6839 8.44129 15 9.20435 15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            AI
          </button>
        )}
        
        <button
          onClick={onPreview}
          className="flex items-center px-3 py-1.5 bg-white border border-gray-300 text-gray-700 rounded-md text-sm hover:bg-gray-50 transition-colors"
          title="Preview"
        >
          <svg className="w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
        </button>
        
        <button
          onClick={onSave}
          disabled={isSaving}
          className="flex items-center px-4 py-1.5 bg-green-600 text-white rounded-md text-sm hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
          title="Save"
        >
          {isSaving ? 'Saving...' : 'Save'}
        </button>
        
        <button
          onClick={onDelete}
          className="flex items-center px-2 py-1.5 text-red-600 rounded-md text-sm hover:bg-red-50 transition-colors"
          title="Delete"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ActivityToolbar; 